import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import DropDownIcon from '../../Assets/Images/dropDownIcon.svg';
import DropDownIconBlack from '../../Assets/Images/arrowdropdown.svg';
import DropDownListIcon from '../../Assets/Images/dropdownListIcon.svg';
import PencilIcon from '../../Assets/Images/pencilEditIcon.svg';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { IconButton } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';
import { nanoid } from 'nanoid';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
    }
  }
};

export default function DropDown({
  placeholder,
  placeholderColor = '#8E8E8E',
  dropdownValue,
  width,
  borderColor,
  name,
  dropDownSelected,
  handleChange,
  handlePenClick = () => {},
  className,
  disabled,
  searchDropdown,
  options,
  background = '',
  multiple = false,
  height,
  borderTopRightRadius,
  selectDisplayProps,
  selectStyles,
  showClear,
  disableClearable,
  iconComponent,
  disableMenuItem = [],
  clearAll,
  handleClearSelection,
  showIconItems = [],
  styles = {},
  esign = false,
  innerStyles = { border: `1px  solid ${borderColor ? borderColor : ' #ECF0E5'}` },
  borderRadius = ''
}) {
  const result = Array.isArray(dropDownSelected) && dropDownSelected?.find(ele => ele.length > 0);

  showClear = showClear && result ? true : false;

  return (
    <div>
      <FormControl sx={{ width: width }}>
        {!searchDropdown ? (
          <>
            <Select
              disabled={disabled}
              style={{ backgroundcolor: 'transparent', ...(selectStyles || {}) }}
              SelectDisplayProps={{ style: selectDisplayProps }}
              sx={{
                position: 'relative',
                height: height,
                background: background || null,
                borderTopRightRadius: borderTopRightRadius || null,
                boxShadow: 'none',
                ...styles,
                '.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select ': {
                  minHeight: '0.4375em'
                },
                '.MuiOutlinedInput-notchedOutline': {
                  ...innerStyles,
                  borderRadius: borderRadius ? borderRadius : '4px'
                },
                ...(disabled
                  ? {}
                  : {
                      '&:hover': {
                        '&& fieldset': {
                          ...innerStyles
                        }
                      }
                    }),
                '.MuiSelect-select': {
                  padding: '9px'
                },
                ...(iconComponent ? { '.MuiSelect-icon': { top: '3px' } } : {})
              }}
              IconComponent={
                iconComponent
                  ? iconComponent
                  : () => (
                      <img
                        style={{ pointerEvents: 'none', position: 'absolute', right: 15 }}
                        src={esign ? DropDownListIcon : background ? DropDownIconBlack : DropDownIcon}
                        className='MuiSvgIcon-root MuiSelect-icon'
                        alt=''
                      />
                    )
              }
              displayEmpty
              value={dropDownSelected}
              name={name}
              multiple={multiple}
              className={className}
              onChange={handleChange}
              defaultValue=''
              renderValue={selected => {
                if (multiple ? selected?.length === 0 : !selected) {
                  return (
                    <div
                      className='medium6'
                      style={{
                        color: placeholderColor
                      }}
                    >
                      {placeholder}
                    </div>
                  );
                }

                if (multiple) {
                  let selectedOption = [];
                  if (Array.isArray(selected)) {
                    if (selected.every(value => typeof value === 'number')) {
                      selectedOption = dropdownValue.filter(option => selected.includes(option.id));
                    } else {
                      selectedOption = dropdownValue.filter(
                        option => selected.includes(option.name) || selected.includes(option.id)
                      );
                    }
                  } else {
                    // Handle the case where selected is a string
                    selectedOption = dropdownValue.find(option => selected === option.id);
                    if (!selectedOption) {
                      selectedOption = dropdownValue.find(option => selected === option.name);
                    }
                    selectedOption = selectedOption ? [selectedOption] : [];
                  }
                  return selectedOption.map(e => e.name).join(', ');
                } else {
                  const selectedOption = dropdownValue.find(option => option.id === selected);
                  return <div className='medium6'>{selectedOption ? selectedOption.name : selected}</div>;
                }
              }}
              input={<OutlinedInput sx={{ border: 0 }} />}
              MenuProps={MenuProps}
            >
              {clearAll?.clear && (
                <MenuItem key='clearAll' value={clearAll?.id} style={{ padding: 12 }}>
                  {clearAll?.name}
                </MenuItem>
              )}
              {dropdownValue?.map((val, i) => (
                <MenuItem
                  key={nanoid()}
                  value={val?.id || val}
                  style={{ padding: 12 }}
                  disabled={disableMenuItem[i] === 0 || disableMenuItem.includes(val)}
                >
                  <span>{val?.name || val}</span>
                  {showIconItems.includes(val) || showIconItems.includes(val.name) ? (
                    <img
                      src={PencilIcon}
                      alt='menu item icon'
                      style={{ marginLeft: 'auto', width: '16px', height: '16px' }}
                      onClick={() => {
                        handlePenClick(val?.id || val);
                      }}
                    />
                  ) : null}
                </MenuItem>
              ))}
            </Select>
            {showClear && (
              <IconButton
                aria-label='clear'
                onClick={handleClearSelection}
                size='small'
                sx={{ position: 'absolute', right: 35, top: 'calc(50% - 12px)', padding: 0 }}
              >
                <GridCloseIcon fontSize='small' />
              </IconButton>
            )}
          </>
        ) : (
          <Autocomplete
            disableClearable={disableClearable}
            id='grouped-demo'
            options={options || []}
            // groupBy={option => option.firstLetter}
            // getOptionLabel={option => option.title}
            value={dropDownSelected}
            onChange={handleChange}
            style={{ maxHeight: '200px' }}
            // componentsProps={{ popper: { style: { width: width } } }}
            sx={{
              boxShadow: 'none',
              '.MuiOutlinedInput-notchedOutline': {
                border: `1px  solid ${borderColor ? borderColor : ' #ECF0E5'}`
              },
              '&:hover': {
                '&& fieldset': {
                  border: `1px solid${borderColor ? borderColor : ' #ECF0E5'}`
                }
              },
              '.MuiOutlinedInput-root': {
                padding: '4px',
                paddingLeft: '4px',
                paddingRight: '40px',
                fontFamily: 'Gilroy-Medium ,sans-serif',
                fontSize: '14px'
              },
              '.MuiAutocomplete-hasPopupIcon .MuiAutocomplete-hasClearIcon .MuiAutocomplete-root .MuiOutlinedInput-root':
                {
                  paddingRight: '53px'
                }
            }}
            renderInput={params => <TextField {...params} placeholder={placeholder} />}
          />
        )}
      </FormControl>
    </div>
  );
}
